/**
 * The canonical Markdown for a question set (ADR-023 §1): the ADR's layout, with no blank lines
 * inside a segment and one blank line between segments. A set that arrives from the render
 * service or the editor is stored as this text, so a diff between two versions is a diff of content.
 */
export function renderQuestions(check) {
    return layoutQuestions(check).text;
}
/** The canonical text and the line each part lands on, which validation uses to position errors. */
export function layoutQuestions(check) {
    const out = [];
    const lines = { segments: [], questions: [] };
    check.segments.forEach((segment, s) => {
        if (s > 0)
            out.push("");
        out.push(`### Segment ${String(segment.n)} · ${segment.label}`);
        lines.segments.push(out.length);
        const questionLines = [];
        lines.questions.push(questionLines);
        segment.questions.forEach((q, i) => {
            out.push(`${String(i + 1)}. ${q.prompt}`);
            const prompt = out.length;
            for (const option of q.options) {
                const text = option.id === q.answer ? `**${option.text}** ✓` : option.text;
                out.push(`   - ${option.id}. ${text}`);
            }
            // Widened on purpose: validateQuestions lays out unchecked JSON, which may lack a citation.
            const citation = q.citation;
            out.push(`   Why: ${q.why} (Guide ${citation?.pages ?? ""})`);
            const why = out.length;
            let beat;
            if (q.beat !== undefined) {
                out.push(`   Beat: ${q.beat}`);
                beat = out.length;
            }
            questionLines.push(beat === undefined ? { prompt, why } : { prompt, why, beat });
        });
    });
    return { text: out.join("\n") + "\n", lines };
}
//# sourceMappingURL=render.js.map